import { Subscribable } from 'knockout';

export interface LazyComponent {
    isComponentReady: Subscribable<boolean>
}

export function isLazyComponent(item: any): item is LazyComponent {
    return _.isObject(item) && ko.isSubscribable(item.isComponentReady);
}